const monthSelector = {
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",
  SelectDate: "select date, the current date selected is {{month}} {{year}}",
  SelectDateYear: "select date, the current date selected is {{year}}",
  SelectAllDates: "select date",
  previousYear: "previous year",
  nextYear: "next year",
  previousMonth: "previous month",
  nextMonth: "next month",
  AllDates: "All dates",
  Clear: "Clear",
} as const;

const common = {
  clear: "Clear",
} as const;

const attachment = {
  removeAttachment: "Remove attachment: {{name}}",
  Remove: "Remove",
  addAttachment: "Add",
  attachmentName: "Attachment: {{name}}",
  showMore: "Show more",
  showLess: "Show less",
} as const;

const searchBar = {
  ClearSearch: "Clear search",
  Search: "Search",
  SearchAriaLabel: "Search input",
} as const;

const dropdown = {
  GoBack: "Go back",
  MoreOptions: "More options",
} as const;

const a11yMenu = {
  AccessibleNavigation: "Accessible navigation",
  SkipToMainContent: "Skip to main content",
} as const;

const breadcrumb = {
  collapsedBreadcrumb: "Collapsed breadcrumb",
} as const;

const countrySelector = {
  dropdownLabel: "Country selector dropdown for phone number",
  defaultCountrySelected: "country code selected",
} as const;

const filterDrawer = {
  clear: "Clear",
  closeButtonLabel: "Close drawer",
  previousMenuLabel: "Back to previous menu",
} as const;

const toast = {
  CloseNotification: "Close notification",
  success: "Success",
  error: "Error",
} as const;

const modal = {
  CloseModal: "Close modal",
} as const;

const button = {
  Loading: "Loading",
};

const pagination = {
  nextPage: "Next page",
  previousPage: "Previous page",
} as const;

const message = {
  dismiss: "Dismiss",
} as const;

const quantitySelector = {
  itemQuantityWidget: "Item quantity widget",
  specifyItemQuantity: "Specify the item quantity",
  buttonIncrement: "Increment item quantity by 1",
  buttonDecrement: "Decrement item quantity by 1",
};

const footer = {
  FullscriptCopyRights: "Fullscript {{currentYear}}. All rights reserved.",
  TermsOfService: "Terms of Service",
  PrivacyStatement: "Privacy Statement",
  AccessibilityPolicy: "Accessibility Policy",
  CaliforniaPrivacyNotice: "California Privacy Notice",
  HelpAndSupport: "Help and Support",
  ShippingPolicy: "Shipping Policy",
  RefundPolicy: "Refund Policy",
  FDAdisclaimerLine1:
    "*These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease.",
  FDAdisclaimerLine2:
    "†Claims based on traditional homeopathic practice, not accepted medical evidence. Not FDA evaluated.",
  ShippingDisclaimer:
    "Please note that all orders placed before 3:00 pm Eastern Standard Time are shipped out the same business day. Orders placed over the weekend or on holidays will be processed the next business day.",
  SecureCheckout: "Fullscript ensures all payment information is <1>stored securely</1>.",
  CarbonZeroAltText: "Carbonzero Certified. CZC-1624-1011-2021",
  SecureCheckoutIcon: "Fullscript secure checkout",
  HIPAAalttext: "Health Insurance Portability and Accountability Act (HIPAA) Compliant",
};

const carousel = {
  next: "Next",
  previous: "Previous",
};

const richTextEditor = {
  richTextArea: "Rich textarea",
  bold: "Bold",
  italic: "Italic",
  unorderedList: "Unordered list",
  orderedList: "Ordered list",
  heading: "Heading",
  link: "Link",
  highlightedLink: "Highlighted link",
  apply: "Apply",
  placeHolderText: "Add a message",
  error: "Rich text error",
} as const;

const aviary = {
  a11yMenu,
  attachment,
  breadcrumb,
  button,
  carousel,
  common,
  countrySelector,
  dropdown,
  filterDrawer,
  footer,
  message,
  modal,
  monthSelector,
  pagination,
  quantitySelector,
  richTextEditor,
  searchBar,
  toast,
};

export { aviary };
